
import "./header.css";

import { useState, useEffect, useRef } from "react";

import { Link, useNavigate } from "react-router-dom";

/* autenticação */
import { auth } from "../../services/firebaseConnection";
import { signOut } from "firebase/auth";

/* redux */
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/user/slice";
import { deleteAgent } from "../../redux/agent/slice";

/* funções auxiliares */
import { registerLog } from "../../services/functions/functions.ts";

/* imagens */
import logo from "../../assets/logo.png";
import menu_mobile from "../../assets/menu-mobile.png";
import close_mobile from "../../assets/close-mobile.png";


export default function Header({access}) {

    const [empresa, setEmpresa] = useState("");
    const [email, setEmail] = useState("");

    const [menuMobile, setMenuMobile] = useState(false);

    /* refs para itens do header */
    const headerRef = useRef(null);
    const mobileMenuRef = useRef(null);

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { user } = useSelector((rootReducer) => rootReducer.user);

    useEffect(() => { 
    
        if(access === 1) {

            let em = user.empresa;
            let ml = user.email;

             setEmpresa(em);
             setEmail(ml);

        }
    
    }, []);

    
    useEffect(() => {

        const handleScroll = () => {
        
            if (!headerRef.current) return;

            if (window.scrollY > 50) {

                headerRef.current.style.setProperty("--header-height", "3.9rem");
                headerRef.current.style.setProperty("--header-height-mobile", "2.9rem");

                headerRef.current.style.setProperty("--logo-company-size", "1.2rem");
                headerRef.current.style.setProperty("--logo-company-size-mobile", "0.8rem");

                headerRef.current.style.setProperty("--logo-desc-size", "0.7rem");
                headerRef.current.style.setProperty("--logo-desc-size-mobile", "0.5rem");

                headerRef.current.style.setProperty("--menu-item-size", "1.1rem");
                headerRef.current.style.setProperty("--menu-item-email", "0.8rem");

                headerRef.current.style.setProperty("--access-item-size", "0.9rem");

                headerRef.current.style.setProperty("--access-item-panel", "0.8rem");
                headerRef.current.style.setProperty("--access-item-exit", "0.8rem");

                headerRef.current.style.setProperty("--menu-mobile-size", "1.4rem");
      
            } else {
        
                headerRef.current.style.setProperty("--header-height", "7.9rem");
                headerRef.current.style.setProperty("--header-height-mobile", "5.9rem");

                headerRef.current.style.setProperty("--logo-company-size", "1.5rem");
                headerRef.current.style.setProperty("--logo-company-size-mobile", "1.2rem");

                headerRef.current.style.setProperty("--logo-desc-size", "1.2rem");
                headerRef.current.style.setProperty("--logo-desc-size-mobile", "0.9rem");

                headerRef.current.style.setProperty("--menu-item-size", "1.4rem");
                headerRef.current.style.setProperty("--menu-item-email", "1.1rem");

                headerRef.current.style.setProperty("--access-item-size", "1.2rem");

                headerRef.current.style.setProperty("--access-item-panel", "1.2rem");
                headerRef.current.style.setProperty("--access-item-exit", "1.2rem");

                headerRef.current.style.setProperty("--menu-mobile-size", "2rem");

            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);

    }, [access]);



    function menu_itens_mobile() {

        setMenuMobile(!menuMobile);
        
        if(access === 0) {
            mobileMenuRef.current.style.setProperty("--menu-access-mobile-size", "9rem");
            mobileMenuRef.current.style.setProperty("--menu-itens-mobile-size", "8.9rem");
        } else {
            mobileMenuRef.current.style.setProperty("--menu-access-mobile-size", "17rem");
            mobileMenuRef.current.style.setProperty("--menu-itens-mobile-size", "16.9rem");
        }
        
        mobileMenuRef.current.className = menuMobile ? "header_menu-mobile_box" : "header_menu-mobile_box open";
    
    }



    async function logout() {

        navigate("/login");

        await signOut(auth);

        registerLog(user.id, "/logout");

        dispatch(logoutUser());
        dispatch(deleteAgent());

        sessionStorage.removeItem('id');
        sessionStorage.removeItem('empresa');
        sessionStorage.removeItem('nome');
        sessionStorage.removeItem('email');
        sessionStorage.removeItem('acesso');

        sessionStorage.removeItem('agente_id');
        sessionStorage.removeItem('agente');
        sessionStorage.removeItem('plano');
        sessionStorage.removeItem('status');

    }
    
    return(
        <div className="header">
            <div ref={headerRef} className="header_content">

                <div className="header_menu_spaceup"></div>
                <div className="header_menu_content">

                    <div className="header_menu_logo">
                        <Link to="/" className="header_menu_logo_link">
                        <div className="header_menu_logo_box">
                            <img className="header_menu_logo_image" src={logo}></img>
                            <div className="header_menu_logo_space"></div>
                            <div className="header_menu_logo_texts">
                                <span className="header_menu_logo_company">winners-ai.com</span>
                                <span className="header_menu_logo_description">AGENTES</span>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div className="header_menu_infos">
                        { access === 1 && (
                        <>
                        <span className="header_menu_itens_company">{ empresa }</span>
                        <span className="header_menu_itens_email">{ email }</span>
                        </>
                        )}
                    </div>

                    <div className="header_menu_itens">
                    { access === 0 ? (
                    <> 
                    <div className="header_menu_itens_off">
                        <Link to="/howitworks" className="header_menu_itens_item">Como funciona</Link>
                        <span className="header_menu_itens_space1"></span>
                        <Link to="/subscription" className="header_menu_itens_item">Planos</Link>
                        <span className="header_menu_itens_space2"></span>
                        <Link to="/login" className="header_menu_access_item">Entrar</Link>
                    </div>
                    </>
                    ) : (
                    <>
                    <div className="header_menu_itens_on">
                        <Link to="/panel" className="header_menu_access_panel">Painel</Link>
                        <div className="header_menu_access_space"></div>
                        <Link onClick={logout} className="header_menu_access_exit">Sair</Link>
                    </div>
                    </>
                    )}

                        {/* menu do mobile */}
                        <div className="header_menu-mobile" onClick={menu_itens_mobile}><img className={`header_menu-mobile_icon menu ${menuMobile ? "hidden" : ""}`} src={menu_mobile} alt="abrir menu" /><img className={`header_menu-mobile_icon close ${menuMobile ? "visible" : ""}`} src={close_mobile} alt="fechar menu" /></div>

                    </div>

                </div>

                <div className="header_menu_spacedown"></div>
                
            </div>

            {/* itens do menu do mobile */}
            <div ref={mobileMenuRef} className="header_menu-mobile_box">
                <div className="header_menu-mobile_line"></div>
                <div className="header_menu-mobile_itens">
                    { access === 0 ? (
                    <>
                    <Link to="/howitworks" className="header_menu_itens_item">Como funciona</Link>
                    <span className="header_menu_itens_space1"></span>
                    <Link to="/subscription" className="header_menu_itens_item">Planos</Link>
                    <span className="header_menu_itens_space2"></span>
                    <Link to="/login" className="header_menu_access_item">Entrar</Link>
                    </>
                    ) : (
                    <>
                    <span className="header_menu_itens_company">{ empresa }</span>
                    <span className="header_menu_itens_email">{ email }</span>

                    <span className="header_menu-mobile_space"></span>
                    <div className="header_menu-mobile_spaceline"></div>
                    <span className="header_menu-mobile_space"></span>
                    
                    <Link to="/panel" className="header_menu_access_panel">Painel</Link>
                    <div className="header_menu_access_space"></div>
                    <Link onClick={logout} className="header_menu_access_exit">Sair</Link>
                    </>
                    )}
                </div>
            </div>

            <div className="header_line"></div>

        </div>
    
    )
}